<template>
  <path
    d="M13.2001 7.07018L10.2501 11.0002L12.5001 14.0002C12.8301 14.4402 12.7401 15.0702 12.3001 15.4002C11.8601 15.7302 11.2301 15.6502 10.9001 15.2002C9.85005 13.8002 8.59005 12.1302 7.80005 11.0602C7.40005 10.5302 6.60005 10.5302 6.20005 11.0602L2.20005 16.3902C1.71005 17.0602 2.18005 18.0002 3.00005 18.0002H21.0001C21.8201 18.0002 22.2901 17.0602 21.8001 16.4002L14.8001 7.07018C14.4001 6.53018 13.6001 6.53018 13.2001 7.07018Z"
  />
</template>
